export default __webpack_public_path__ + "static/media/relative-bold-pro.795575f5.woff";